/**
 * Created by OLD on 20/08/2015.
 */
define('graphicalRequestAllInOneRouter',[
    'require',
    'exports',
    'module',
    'logger',
    'marionette',
    'app',
    'itemPagesNameMixin'
], function(
    require,
    exports,
    module,
    Logger,
    Marionette,
    App,
    ItemPagesNameMixin
) {
  'use strict';

  var GraphicalRequestAllInOneRouter = Marionette.AppRouter.extend({
    appRoutes: {
      'graphical_service_all_in_one': 'showAllInOne',
      'graphical_service_all_in_one/:secId' : 'showAllInOne'
    }
  });

  var API = {
    showAllInOne: function(secId) {
      require([
        'graphicalRequestAllInOneShowController',
        'contentShowController',
        'ticketsAllController'
      ], function(ShowController, ContentShowController, TicketsController) {
        ContentShowController.showContent().done(function() {
          App.startSubModule('graphicalRequestAllInOneMain');
          if ( !secId ) {
            ShowController.showAllInOne();
          } else if (secId === 'new' ) {
            ShowController.showAllInOne({isNew: true});
          } else {
            TicketsController.showTickets(secId);
          }
          App.execute('set:active:nav:item', ItemPagesNameMixin.GRAPHICALREQUESTS_ALL_IN_ONE);
        });
      });
    }
  };

  App.on('graphical_service_all_in_one:show', function(secId) {
    if (secId) {
      App.navigate('graphical_service_all_in_one/' + secId);
    } else {
      App.navigate('graphical_service_all_in_one');
    }
    API.showAllInOne(secId);
  });

  App.on('graphical_service_all_in_one:new', function() {
    App.navigate('graphical_service_all_in_one/new');
    API.showAllInOne('new');
  });

  App.on('before:start', function() {
    new  GraphicalRequestAllInOneRouter({
      controller: API
    });
  });

  module.exports = GraphicalRequestAllInOneRouter;
});
